import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import TermsModal from '../components/TermsModal';
import './Login.css'; // Login ile aynı CSS kullanıyoruz

const Register: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    email: '',
    password: '',
    confirmPassword: '',
    acceptTerms: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
    // Hata mesajını kaldırma - kullanıcı görebilsin diye
    // setError(''); // Bu satırı kaldırdık
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    // Validasyon
    if (formData.password !== formData.confirmPassword) {
      setError('Şifreler eşleşmiyor!');
      return;
    }

    if (formData.password.length < 6) {
      setError('Şifre en az 6 karakter olmalıdır!');
      return;
    }

    if (!formData.acceptTerms) {
      setError('Kullanım şartlarını kabul etmelisiniz!');
      return;
    }

    setLoading(true);

    try {
      const response = await authAPI.register({
        name: formData.name,
        surname: formData.surname,
        email: formData.email,
        password: formData.password,
      });

      // Email doğrulama gerekiyorsa verification sayfasına yönlendir
      if (response.data.requiresVerification) {
        navigate('/verify-email', { state: { email: formData.email } });
      } else {
        // Eski kullanıcılar için (email doğrulama yoksa) login'e yönlendir
        navigate('/login');
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'Kayıt başarısız. Lütfen bilgilerinizi kontrol edin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-split-container">
      {/* Sol Taraf - Görsel Alan */}
      <div className="login-visual-side">
        <div className="visual-overlay"></div>
        <div className="visual-content">
          <div className="visual-logo">
            <i className="bi bi-bank2"></i>
          </div>
          <h1 className="visual-title">Karadaş Hukuk Bürosu</h1>
          <p className="visual-subtitle">Dijital Dönüşümün Merkezi</p>
          <div className="visual-features">
            <div className="feature-item">
              <i className="bi bi-person-check"></i>
              <span>Hızlı Kayıt</span>
            </div>
            <div className="feature-item">
              <i className="bi bi-shield-lock"></i>
              <span>Güvenli Sistem</span>
            </div>
            <div className="feature-item">
              <i className="bi bi-clock-history"></i>
              <span>Anında Erişim</span>
            </div>
          </div>
        </div>
      </div>

      {/* Sağ Taraf - Form Alanı */}
      <div className="login-form-side">
        <div className="form-container">
          {/* Başlık */}
          <div className="form-header">
            <h1 className="form-main-title">Hesap Oluştur</h1>
            <p className="form-subtitle">Sisteme erişim sağlamak için bilgilerinizi girin</p>
          </div>

          {/* Hata Mesajı */}
          {error && (
            <div className="error-message">
              <i className="bi bi-exclamation-circle-fill"></i>
              <span>{error}</span>
            </div>
          )}

          {/* Form */}
          <form onSubmit={handleSubmit} className="login-form">
            {/* Ad Soyad - Yan Yana */}
            <div className="form-row">
              <div className="form-group form-group-half">
                <label htmlFor="name" className="form-label">
                  <i className="bi bi-person"></i>
                  Ad
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-input"
                  placeholder="Adınız"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group form-group-half">
                <label htmlFor="surname" className="form-label">
                  <i className="bi bi-person"></i>
                  Soyad
                </label>
                <input
                  type="text"
                  id="surname"
                  name="surname"
                  className="form-input"
                  placeholder="Soyadınız"
                  value={formData.surname}
                  onChange={handleChange}
                  required
                  disabled={loading}
                />
              </div>
            </div>

            {/* E-posta Alanı */}
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                <i className="bi bi-envelope"></i>
                E-posta Adresi
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-input"
                placeholder="ornek@email.com"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>

            {/* Şifre Alanı */}
            <div className="form-group">
              <label htmlFor="password" className="form-label">
                <i className="bi bi-lock"></i>
                Şifre
              </label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  className="form-input password-input"
                  placeholder="••••••••"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  minLength={6}
                  disabled={loading}
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                </button>
              </div>
            </div>

            {/* Şifre Tekrar Alanı */}
            <div className="form-group">
              <label htmlFor="confirmPassword" className="form-label">
                <i className="bi bi-lock-fill"></i>
                Şifre Tekrar
              </label>
              <div className="password-input-wrapper">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  id="confirmPassword"
                  name="confirmPassword"
                  className="form-input password-input"
                  placeholder="••••••••"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                  minLength={6}
                  disabled={loading}
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  tabIndex={-1}
                >
                  <i className={`bi ${showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                </button>
              </div>
            </div>

            {/* Kullanım Şartları */}
            <div className="form-options" style={{ justifyContent: 'flex-start' }}>
              <label className="remember-me">
                <input
                  type="checkbox"
                  name="acceptTerms"
                  checked={formData.acceptTerms}
                  onChange={handleChange}
                  className="custom-checkbox"
                />
                <span className="checkbox-label">
                  <span
                    className="terms-link-inline"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowTermsModal(true);
                    }}
                    style={{ cursor: 'pointer', textDecoration: 'underline', color: '#C2956E' }}
                  >
                    Kullanım şartlarını
                  </span>
                  {' '}kabul ediyorum
                </span>
              </label>
            </div>

            {/* Kayıt Butonu */}
            <button
              type="submit"
              className="submit-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-icon"></span>
                  Kayıt yapılıyor...
                </>
              ) : (
                <>
                  <i className="bi bi-person-plus"></i>
                  Kayıt Ol
                </>
              )}
            </button>
          </form>

          {/* Alt Bilgi */}
          <div className="form-footer">
            <p className="footer-text">
              Zaten hesabınız var mı?{' '}
              <Link to="/login" className="register-link">
                Giriş Yap
              </Link>
            </p>
          </div>

          {/* Güvenlik Bilgisi */}
          <div className="security-info">
            <i className="bi bi-shield-lock"></i>
            <span>Bilgileriniz SSL ile şifrelenmektedir</span>
          </div>
        </div>
      </div>

      {/* Terms Modal */}
      <TermsModal isOpen={showTermsModal} onClose={() => setShowTermsModal(false)} />
    </div>
  );
};

export default Register;
